<template>
  <a-drawer
    :open="open"
    class="custom-class"
    root-class-name="root-class-name"
    placement="right"
    @close="close"
  >
    <section class="" v-show="!firstFormDone">
      <div class="">
        <Text :type="'subHeader'" :text="'Edit Depot'" />

        <Text :type="'textFadedMedium'" :text="'Change details for depot'" />

        <form class="my-6" @submit.prevent="handleSubmit">
          <div class="mb-2 cre">
            <div class="block">
              <LabelText :forVal="'depot group'" labelText="Depot Group:" />
            </div>
            <!-- dropdown -->
            <div class="flex items-center border-2 rounded-lg">
              <Dropdown
                class="w-[90%] placeholder:text-xs text-xs"
                v-model="form.depotGroup"
                :options="depotGroups"
                filter
                optionLabel="name"
                optionValue="name"
                placeholder="Select a Group"
              >
                <template #option="slotProps">
                  <div class="flex align-items-center">
                    <div>{{ slotProps.option.name }}</div>
                  </div>
                </template>
              </Dropdown>
              <div @click="showModal">
                <span class="pi pi-plus-circle"></span>
              </div>
            </div>
          </div>

          <!--  -->

          <div class="">
            <LabelText :forVal="'depot_name'" :labelText="'Depot name'" />
            <input
              class="w-full px-4 py-2 text-sm border rounded-md border-foundationGrey500 font-quietSans placeholder-foundationGrey500 outline-foundationGrey500 focus:border-foundationGrey500"
              v-model="form.name"
              :placeholder="'Enter depot name'"
              :name="'depotName'"
              :type="'string'"
              :value="form.name"
            />
            <!-- <DrawerInput
              :placeholder="'Enter depot name'"
              :name="'depot_name'"
              v-model="form.name"
              :type="'text'"
              :val="'Oluwaferanmi'"
            /> -->
          </div>

          <div class="mt-3">
            <LabelText :forVal="'phone-number'" labelText="Phone number" />

            <input
              class="w-full px-4 py-2 text-sm border rounded-md border-foundationGrey500 font-quietSans placeholder-foundationGrey500 outline-foundationGrey500 focus:border-foundationGrey500"
              v-model="form.phone"
              :placeholder="'Enter phone number'"
              :name="'depotPhone'"
              :type="'string'"
              :value="form.phone"
            />
          </div>

          <div class="mt-3">
            <LabelText :forVal="'state'" :labelText="'State'" />

            <select
              class="w-full px-4 py-2 text-base bg-transparent border rounded-lg border-grey300 font-quietSans placeholder-grey500 outline-foundationGrey500 focus:border-foundationGrey500"
              name="name"
              :value="form.state"
              id=""
              v-model="form.state"
            >
              <option value="" selected disabled>Select state</option>
              <option
                v-for="state in stateList"
                :key="state"
                :value="state.name"
              >
                {{ state.name }}
              </option>
            </select>
          </div>

          <div class="mt-3">
            <LabelText :forVal="'city'" labelText="Depot City" />

            <input
              class="w-full px-4 py-2 text-sm border rounded-md border-foundationGrey500 font-quietSans placeholder-foundationGrey500 outline-foundationGrey500 focus:border-foundationGrey500"
              v-model="form.city"
              :placeholder="'Enter depot city'"
              :name="'depotCity'"
              :type="'string'"
              :value="form.city"
            />
          </div>

          <div class="mt-3">
            <LabelText :forVal="'houseNo'" labelText="House no" />

            <input
              class="w-full px-4 py-2 text-sm border rounded-md border-foundationGrey500 font-quietSans placeholder-foundationGrey500 outline-foundationGrey500 focus:border-foundationGrey500"
              v-model="form.houseNo"
              :placeholder="'Enter House No'"
              :name="'houseNo'"
              :type="'string'"
              :value="form.houseNo"
            />
          </div>

          <div class="mt-3">
            <LabelText :forVal="'street'" labelText="Street Address" />

            <input
              class="w-full px-4 py-2 text-sm border rounded-md border-foundationGrey500 font-quietSans placeholder-foundationGrey500 outline-foundationGrey500 focus:border-foundationGrey500"
              v-model="form.street"
              :placeholder="'Enter street'"
              :name="'street'"
              :type="'string'"
              :value="form.street"
            />
          </div>

          <div class="mt-3">
            <LabelText :forVal="'street'" labelText="Postal Code" />

            <input
              class="w-full px-4 py-2 text-sm border rounded-md border-foundationGrey500 font-quietSans placeholder-foundationGrey500 outline-foundationGrey500 focus:border-foundationGrey500"
              v-model="form.postalCode"
              :placeholder="'Enter Postal Code'"
              :name="'postalCode'"
              :type="'string'"
              :value="form.postalCode"
            />
          </div>

          <div class="mt-3">
            <LabelText :forVal="'code'" labelText="Depot Code" />

            <input
              class="w-full px-4 py-2 text-sm border rounded-md border-foundationGrey500 font-quietSans placeholder-foundationGrey500 outline-foundationGrey500 focus:border-foundationGrey500"
              v-model="form.code"
              :placeholder="'Enter depot code'"
              :name="'depotCode'"
              :type="'string'"
              :value="form.code"
            />
          </div>

          <div class="mt-4">
            <Text :type="'form-label'" :text="'Upload depot image'" />
            <div
              class="relative px-4 py-3 mt-2 text-center border rounded-lg border-grey300"
            >
              <span
                v-show="imgUrl"
                class="absolute flex justify-center cursor-pointer top-2 right-2"
              >
                <input
                  type="file"
                  name="depotImage"
                  @change="handleFileUpload"
                  class="w-[20px] h-[40px] opacity-0 absolute"
                />
                <img src="@/assets/svg/upload.svg" />
              </span>
              <span v-if="imgUrl" class="flex justify-center mb-2">
                <img :src="imgUrl" class="w-[120px] h-[120px] rounded-lg" />
              </span>
              <div v-show="!imgUrl">
                <span class="relative flex justify-center cursor-pointer">
                  <input
                    type="file"
                    name="depotImage"
                    @change="handleFileUpload"
                    class="w-[20px] h-[40px] opacity-0 absolute"
                  />
                  <img src="@/assets/svg/upload.svg" />
                </span>
              </div>
              <p v-show="!imgUrl" class="text-sm text-grey700 font-quietSans">
                Click to
                <span v-if="imgUrl">Change Image</span>
                <span v-else>Upload Image</span>
              </p>
              <p v-show="!imgUrl" class="text-sm text-foundationGrey900">
                PNG, JPG (max. 800x400px)
              </p>

              <p class="text-sm text-foundationGrey900">
                {{ imageName }}
              </p>
            </div>
          </div>

          <div class="flex justify-center mt-3">
            <SubmitButton :val="'Edit depot'" :loading="this.loading" />
          </div>
        </form>
      </div>
    </section>
    <section v-show="firstFormDone">
      <div>
        <Text :type="'subHeader'" :text="'Select product and limit'" />
        <Text :type="'textFadedMedium'" :text="'Set product and limit'" />
      </div>

      <div v-if="activeProducts.length" class="mt-2">
        <div v-bind:key="index" v-for="(product, index) in activeProducts">
          <div
            class="flex items-center justify-between px-3 py-2 mb-3 border rounded-lg border-grey300"
          >
            <div>
              <div class="flex items-center">
                <span>
                  <img src="@/assets/svg/productPms.svg" />
                </span>
                <span class="text-sm text-grey500">
                  {{ product.productName }}
                </span>
              </div>
              <div>
                <p class="mt-2 text-base text-grey500">
                  {{ product.productPrice }}
                </p>
              </div>
            </div>
            <div @click="editProduct(product)" class="cursor-pointer">
              <img src="@/assets/svg/edit.svg" />
            </div>
          </div>
        </div>
      </div>
      <div class="mt-4">
        <Text type="form-label" :text="'Select product and limit'" />
        <form @submit.prevent="mapProductDepot">
          <!-- <div
            class="box-border p-2 mt-4 overflow-x-hidden border rounded-lg border-foundationGrey50"
            v-for="product in depotProducts"
            v-bind:key="product.id"
          >
            <flex-wrapper :justifyB="true">
              <p class="font-quietSans text-coolGrey">{{ product.name }}</p>
              <div>
                <a-switch
                  :checked="newSelectedProducts.includes(product.id)"
                  @change="selectChanged(product.id)"
                  :checkedValue="true"
                  :unCheckedValue="false"
                  class="border border-[red] bg-foundationGrey50"
                />
              </div>
             
            </flex-wrapper>
          </div> -->

          <div class="mt-3">
            <LabelText
              :forVal="'productSelect'"
              :labelText="'Select product'"
            />
            <select
              class="w-full px-4 py-2 border-[1px] text-base bg-transparent rounded-lg border-grey300 font-quietSans placeholder-grey500 outline-foundationGrey500 focus:border-foundationGrey500"
              name="name"
              v-model="productName"
              :value="productName"
            >
              <option value="" selected disabled>Select a product</option>
              <option
                :value="product.name"
                v-bind:key="product.id"
                v-for="product in depotProducts"
              >
                {{ product.name }}
              </option>
            </select>
          </div>

          <div class="mt-3">
            <LabelText
              :forVal="'product_volume'"
              :labelText="'Product Price'"
            />

            <input
              class="w-full px-4 py-2 text-sm rounded-md border-[1px] border-foundationGrey500 font-quietSans placeholder-foundationGrey500 outline-foundationGrey500 focus:border-foundationGrey500"
              v-model="productPrice"
              :placeholder="'Set product price'"
              :name="'productPrice'"
              :type="'text'"
              :value="productPrice"
            />
          </div>

          <div class="mt-3">
            <LabelText :forVal="'startDate'" :labelText="'Select Start Date'" />
            <VueDatePicker
              color="#00903a"
              input-size="sm"
              v-model="startDate"
              :min-date="todayDate"
              no-label
              format="YYYY-MM-DDTHH:mm:ss"
              type="datetime"
            />
          </div>

          <div class="mt-3">
            <LabelText :forVal="'date'" :labelText="'Select End Date'" />
            <VueDatePicker
              color="#00903a"
              input-size="sm"
              v-model="endDate"
              :min-date="todayDate"
              no-label
              format="YYYY-MM-DDTHH:mm:ss"
              type="datetime"
            />
          </div>

          <div
            v-if="depotProducts?.length > 1"
            class="flex items-center my-2 cursor-pointer"
            @click="addProduct"
          >
            <span><img src="@/assets/svg/addGreen.svg" /></span>
            <p class="ml-2 text-sm text-primaryGreen">Add more product</p>
          </div>

          <div class="mt-4">
            <FormSubmitInput
              :loading="secondFormLoading"
              :val="'Map Product'"
            />
          </div>
        </form>
      </div>
      <CreateDepotGroupModalVue
        :getDepotGroups="getDepotGroups"
        :handleOk="handleOk"
        :isOpen="isOpen"
        :close="close"
      />
    </section>
  </a-drawer>
</template>

<script>
import Text from "@/components/UI/Text/Text.vue";
import DrawerInput from "@/components/UI/Inputs/DrawerInput.vue";
import LabelText from "@/components/UI/Text/LabelText.vue";
import SelectWrapper from "@/components/UI/Selects/DrawerSelect.vue";
import FadedBorderWrapper from "@/components/UI/Wrappers/FadedBorderWrapper.vue";
import CheckInput from "@/components/UI/Inputs/CheckInput.vue";
import SubmitButton from "@/components/UI/Inputs/FormSubmitInput.vue";
import depotService from "@/services/depot-service";
import utilityService from "@/services/utility-service";

import { useToast } from "vue-toastification";
import AddProductDepot from "@/components/pages/Depot/AddProductDepot.vue";
import FlexWrapper from "@/components/UI/Wrappers/FlexWrapper.vue";
import FormSubmitInput from "@/components/UI/Inputs/FormSubmitInput.vue";
import CreateDepotGroupModalVue from "@/components/pages/Depot/Modal/DepotGroupModal.vue";
export default {
  props: ["open", "close", "depotDetails", "handleReset"],
  components: {
    CreateDepotGroupModalVue,
    Text,
    DrawerInput,
    AddProductDepot,
    LabelText,
    SelectWrapper,
    FadedBorderWrapper,
    FlexWrapper,
    CheckInput,
    SubmitButton,
    FormSubmitInput,
  },
  data() {
    return {
      stateList: [],
      testId: "Depot General",
      depotGroups: [],
      todayDate: "",
      isOpen: false,
      toast: useToast(),
      depotName: "",
      number: "",
      loading: false,
      depotProducts: [],
      checked: false,
      selectedProducts: [],
      firstFormDone: false,
      secondFormLoading: false,
      newSelectedProducts: [],
      imageName: "",
      imgUrl: this.depotDetails?.imageUrl,
      newDepotId: "",
      activeProducts: [],
      productVolume: "",
      productName: "",
      newPrice: "",
      startDate: "",
      depotGroups: [],
      endDate: "",
      productPrice: "",
      newVolume: "",
      form: {
        name: this.depotDetails.name,
        phone: this.depotDetails.phone,
        city: this.depotDetails.city,
        country: "Nigeria",
        state: this.depotDetails.state,
        houseNo: this.depotDetails.houseNo,
        street: this.depotDetails.street,
        code: this.depotDetails.code,
        depotGroup: this.depotDetails.depotGroupName,
        postalCode: this.depotDetails.postalCode,
        depotImage: this.depotDetails.imageUrl,
      },
    };
  },

  mounted() {
    this.handleGetProduct();
    this.getDepotGroups();
    this.getCountriesStates();
  },

  watch: {
    // depotDetails(details) {
    //   if (details) {
    //     this.imgUrl = this.details.imageUrl;
    //   }
    // },
  },

  methods: {
    //utilities
    handleDropdownChange() {
      // Handle the selected option change here
      console.log("Selected Option: " + this.selectedOption);
    },
    async getCountriesStates() {
      try {
        // const result = await utilityService.fecthCountriesStates(this.country);
        const result = await utilityService.fecthCountriesStates("Nigeria");
        if (result) {
          this.stateList = result.data;
        }
      } catch (err) {}
    },
    async getDepotGroups() {
      this.showLoader = true;

      try {
        const result = await depotService.getDepotGroups();

        if (result) {
          this.depotGroups = result.data;
        }
        this.showLoader = false;
      } catch (err) {
        this.showLoader = false;
      }
    },
    stripNonNumber(val) {
      return val
        .split("")
        .map((item) => {
          return !isNaN(item) ? item : "";
        })
        .join("")
        .replaceAll(" ", "");
    },
    editProduct(product) {
      this.productName = product.productName;
      this.newPrice = product.newPrice;
      // this.productVolume = product.productVolume;
      this.startDate = product.startDate;
      this.endDate = product.endDate;
      this.productPrice = product.productPrice;
      // this.newVolume = product.newVolume;
    },
    showModal() {
      this.isOpen = true;
    },
    handleOk() {
      this.isOpen = false;
    },
    readFile(file_) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const fileContent = event.target.result;
        this.imgUrl = fileContent;
      };

      reader.readAsDataURL(file_);
    },
    validateData() {
      if (
        !this.productName ||
        !this.startDate ||
        !this.endDate ||
        // !this.productVolume ||
        !this.productPrice
        // || !this.newVolume
      ) {
        return false;
      }
      return true;
    },

    resetFields() {
      (this.productName = ""),
        (this.newPrice = ""),
        (this.startDate = ""),
        (this.endDate = ""),
        // (this.productVolume = "");
        (this.productPrice = "");
      // this.newVolume = "";
    },
    resolveId(productName) {
      return this.depotProducts.find((item) => item.name == productName).id;
    },
    addProduct() {
      // Validate before pushing
      if (!this.validateData()) {
        this.toast.error(
          "All fields for the current product should be filled",
          { timeout: 5000 }
        );
        return;
      }

      const findVal = this.activeProducts.findIndex(
        (item) => item.productName == this.productName
      );

      // Update if you find a new one
      if (findVal !== -1) {
        this.activeProducts[findVal] = {
          productName: this.productName,
          newPrice: this.newPrice,
          // productVolume: this.productVolume,
          startDate: this.startDate,
          endDate: this.endDate,
          productPrice: this.productPrice,
          productId: this.resolveId(this.productName),
          // newVolume: this.newVolume,
        };
      } else {
        // create a new one
        this.activeProducts.push({
          productName: this.productName,
          newPrice: this.newPrice,
          // productVolume: this.productVolume,
          startDate: this.startDate,
          endDate: this.endDate,
          productId: this.resolveId(this.productName),
          productPrice: this.productPrice,
          // newVolume: this.newVolume,
        });
      }

      this.resetFields();
    },

    //Requests

    handleFileUpload(e) {
      const imgProp = e.target.files[0];
      if (imgProp) {
        if (
          imgProp.type.toLowerCase().includes("jpg") ||
          imgProp.type.toLowerCase().includes("jpeg") ||
          imgProp.type.toLowerCase().includes("png")
        ) {
          if (imgProp.size <= 1000000) {
            this.form.depotImage = e.target.files[0];
            this.readFile(e.target.files[0]);
            this.imageName = e.target.files[0].name;
          } else {
            this.toast.error("Only a file with size of 1mb is allowed");
          }
        } else this.toast.error("Wrong File Format", { timeout: 3000 });
      } else {
        this.form.depotImage = "";
      }
    },
    closeDrawer() {
      this.open = false;
    },
    selectChanged(id) {
      if (this.newSelectedProducts.includes(id)) {
        const indExisting = this.newSelectedProducts.indexOf(id);
        this.newSelectedProducts.splice(indExisting, 1);
        return;
      }
      this.newSelectedProducts = [...this.newSelectedProducts, id];
      // if (this.selectedProducts[index].selected) {
      //   const { minCapacity, maxCapacity, ...rest } =
      //     this.selectedProducts[index];
      //   this.selectedProducts[index] = {
      //     ...rest,
      //     selected: false,
      //   };
      // } else {
      //   this.selectedProducts[index].selected = true;
      // }
    },
    async mapProductDepot(e) {
      this.secondFormLoading = true;
      if (!this.validateData()) {
        this.toast.error(
          "All fields for the current product should be filled",
          { timeout: 5000 }
        );
        this.loading = false;
        return;
      }
      this.addProduct();

      // convert the data gotten to the correct form
      const payload = this.activeProducts.madepotGroupp((item) => {
        return {
          productId: item.productId,
          price: +this.stripNonNumber(item.productPrice),
          // maxCapacity: +this.stripNonNumber(item.productVolume),
          // currentQuantity: +this.stripNonNumber(item.newVolume),
          startDate: item.startDate,
          endDate: item.endDate,
        };
      });

      try {
        const mapSales = await depotService.changeDepotPrice(
          `Depot/AddProductSale?depotId=${this.newDepotId}`,
          payload
        );

        this.toast.success("Depot Product Price mapped successfully", {
          timeout: 2000,
        });
        this.getDepotDetails();
        this.closeDrawer();
      } catch (e) {
      } finally {
        this.secondFormLoading = false;
      }

      // if (!this.newSelectedProducts.length) {
      //   this.toast.error("Kindly Choose a product", { timeout: 3000 });
      //   this.secondFormLoading = false;
      //   return;
      // }
      // try {
      //   const mapResult = await depotService.mapDepotProducts({
      //     depotId: this.newDepotId,
      //     productId: this.newSelectedProducts,
      //   });
      //   this.toast.success("Product Mapped Successfully", { timeout: 2000 });
      // } catch (e) {
      //   this.toast.error(e, { timeout: 3000 });
      // } finally {
      //   this.secondFormLoading = false;
      // }
    },
    async handleGetProduct() {
      try {
        const depotProducts = await depotService.getProducts();
        this.depotProducts = depotProducts.data;
        const nSelectedProduct = depotProducts.data.map((item) => {
          return { selected: false, productId: item.id };
        });
        this.selectedProducts = nSelectedProduct;
      } catch (e) {
        this.toast.error("Couldn't fetch depot product", { timeout: 2000 });
      }
    },
    collectProductData(e, currIndex, left, right) {
      if (right) {
        this.selectedProducts[currIndex].maxCapacity = e.target.value;
      }
      if (left) {
        this.selectedProducts[currIndex].minCapacity = e.target.value;
      }
    },

    handleValidation() {
      const {
        name,
        phone,
        city,
        country,
        state,
        houseNo,
        street,
        code,
        depotGroup,
        postalCode,
        depotImage,
      } = this.form;

      if (
        !name ||
        !phone ||
        !city ||
        !country ||
        !state ||
        !houseNo ||
        !street ||
        !code ||
        !depotGroup ||
        !postalCode ||
        !depotImage
      ) {
        return false;
      }
      return true;
    },
    async handleSubmit() {
      this.loading = true;

      if (!this.handleValidation()) {
        this.form.depotGroup = this.form.depotGroup.id;
        this.toast.error("All fields are required", { timeout: 3000 });
        this.loading = false;
        return;
      }

      const { ...data } = this.form;

      // Get Depot Group id
      const depotGroupId = this.depotGroups.find(
        (item) => item.name === data.depotGroup
      ).id;

      const formData = new FormData();
      formData.append("Code", data.code);
      formData.append("Name", data.name);
      formData.append("Street", data.street);
      formData.append("City", data.city);
      formData.append("State", data.state);
      formData.append("Country", data.country);
      formData.append("HouseNo", data.houseNo);
      formData.append("Phone", data.phone);
      formData.append("PostalCode", data.postalCode);
      if (data.depotImage) {
        formData.append("DepotImage", data.depotImage);
      }
      formData.append("DepotGroupId", depotGroupId);
      const urlParam = new URLSearchParams(window.location.search);

      try {
        const result = await depotService.editDepot(
          urlParam.get("id"),
          formData
        );
        this.newDepotId = result.data;
        if (result) {
          this.loading = false;
          this.toast.success("Depot updated Successfully", { timeout: 2000 });
          this.handleReset();
          this.close("close");
        }
      } catch (error) {
        this.loading = false;
        this.toast.error("An unexpected error ccured", {
          timeout: 2000,
        });
      }
    },
  },
};
</script>

<style>
.cre .p-inputtext {
  font-size: 13px;
  padding: 10px 15px;
  outline: none;
}
.cre .p-focus {
  box-shadow: none;
  outline: none;
}
</style>
